import React from "react";
import { ListGroup, ListGroupItem, Badge, Spinner } from "reactstrap";
import { BUSINESS_RULES_CATEGORIES, BUSINESS_RULES_DEFINITIONS } from "../../../../models/businessRule";

/**
 * BusinessRulesSidebar
 * Sidebar com as categorias de regras de negócio.
 * Mesmo layout visual da AutomationSidebar.
 */
const BusinessRulesSidebar = ({ activeCategoryId, onSelectCategory, loading }) => {

    if (loading) {
        return (
            <div className="border border-top rounded-0 h-100 overflow-hidden bg-white">
                <div className="text-center py-5">
                    <Spinner color="primary" size="sm" />
                    <p className="text-muted small mt-2">Carregando...</p>
                </div>
            </div>
        );
    }

    // Contar regras por categoria
    const countByCategory = {};
    BUSINESS_RULES_CATEGORIES.forEach(cat => {
        countByCategory[cat.id] = BUSINESS_RULES_DEFINITIONS.filter(r => r.category === cat.id).length;
    });

    return (
        <div className="border border-top rounded-0 h-100 overflow-hidden bg-white d-flex flex-column">
            <div className="bg-white border-bottom py-3 px-4">
                <div className="d-flex align-items-start overflow-hidden">
                    <i className="mdi mdi-shield-check-outline text-primary font-size-22 me-2 mt-1"></i>
                    <div className="overflow-hidden">
                        <h6 className="mb-0 fw-bold text-dark text-truncate">Regras de Negócio</h6>
                        <p className="text-muted small mb-0 text-truncate">
                            {BUSINESS_RULES_DEFINITIONS.length} regra{BUSINESS_RULES_DEFINITIONS.length !== 1 ? 's' : ''} configuráve{BUSINESS_RULES_DEFINITIONS.length !== 1 ? 'is' : 'l'}
                        </p>
                    </div>
                </div>
            </div>

            <ListGroup flush className="flex-grow-1 overflow-auto custom-scrollbar">
                {BUSINESS_RULES_CATEGORIES.map(cat => {
                    const isActive = activeCategoryId === cat.id;
                    const total = countByCategory[cat.id];

                    return (
                        <ListGroupItem
                            key={cat.id}
                            tag="button"
                            action
                            onClick={() => onSelectCategory(cat.id)}
                            className={`border-0 py-3 px-4 d-flex align-items-center justify-content-between transition-all select-none cursor-pointer rounded-0 ${isActive ? 'bg-primary bg-opacity-10' : 'hover-bg-light'}`}
                            style={{
                                borderLeft: isActive ? "4px solid var(--bs-primary)" : "4px solid transparent"
                            }}
                        >
                            <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div className="flex-shrink-0 me-3">
                                    <i className={`mdi ${cat.icon} font-size-20 ${isActive ? 'text-primary' : 'text-secondary'}`} style={{ marginTop: '2px' }}></i>
                                </div>
                                <div className="text-start overflow-hidden">
                                    <h6 className={`mb-0 fw-semibold text-truncate font-size-14 ${isActive ? 'text-primary' : 'text-dark'}`}>
                                        {cat.id}
                                    </h6>
                                    <span className="text-muted small" style={{ fontSize: '11px' }}>
                                        {cat.description}
                                    </span>
                                </div>
                            </div>

                            <Badge
                                color="primary"
                                pill
                                className="bg-opacity-10 text-primary font-size-10 px-2 rounded-0"
                                style={{ backgroundColor: 'transparent' }}
                            >
                                {total} regra{total !== 1 ? 's' : ''}
                            </Badge>
                        </ListGroupItem>
                    );
                })}
            </ListGroup>
        </div>
    );
};

export default BusinessRulesSidebar;
